import { gql } from "@apollo/client";

export const BLOCK_CHAT = gql`
  mutation blockChat($chatId: String!, $block: Boolean!) {
    setBlockChat(chatId: $chatId, block: $block) {
      _id
      unreadMessagesCount
      type
      otherPrivateChatMember {
        _id
        username
        profilePicture
        onHoliday
      }
      title
      picture
      isBlockedBy {
        _id
        username
      }
    }
  }
`;
